// extracted by mini-css-extract-plugin
module.exports = {"policy":"ck_b2","underline":"ck_b3","thanksTitle":"ck_hx"};